<nav class="anc-breadcrumb" aria-label="Breadcrumb">
    <ol class="anc-breadcrumb__list">
        @for (
            item of items();
            track trackBreadcrumbItem($index, item);
            let last = $last;
            let first = $first
        ) {
            <li
                class="anc-breadcrumb__item"
                [class.anc-breadcrumb__item--primary]="first"
            >
                @if (!first) {
                    <i
                        class="icon icon--16 icon-chevron-right anc-breadcrumb__separator"
                        aria-hidden="true"
                    ></i>
                }
                @if (first && moduleIcon()) {
                    <i
                        class="icon icon--24 anc-breadcrumb__module-icon"
                        [ngClass]="moduleIcon()"
                        aria-hidden="true"
                    ></i>
                }
                @if (!last && item.route) {
                    <a [routerLink]="item.route" class="anc-breadcrumb__link" translate>{{
                        item.label
                    }}</a>
                } @else {
                    <span
                        class="anc-breadcrumb__current"
                        [attr.aria-current]="last ? 'page' : null"
                        translate
                        >{{ item.label }}</span
                    >
                }
            </li>
        }
    </ol>
    <ng-content></ng-content>
</nav>
